function createEventEmitter() {
  const eventSubscribers = new Map();
  return {
    emit(eventName, event) {
      const subscribers = eventSubscribers.get(eventName);
      for (const subscriber of subscribers !== null && subscribers !== void 0 ? subscribers : []) {
        subscriber(event);
      }
    },
    on(eventName, subscriber) {
      if (!eventSubscribers.has(eventName)) {
        eventSubscribers.set(eventName, new Set([subscriber]));
      } else {
        eventSubscribers.get(eventName).add(subscriber);
      }
      return () => {
        const set = eventSubscribers.get(eventName);
        set.delete(subscriber);
        if (set.size === 0) {
          eventSubscribers.delete(eventName);
        }
      };
    }
  };
}
export const eventEmitter = createEventEmitter();